<template>
  <div class="user-management2">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div slot="header" class="clearfix">
        <span style="font-size:18px;font-weight:600;">用户个人收益比例管理</span>
      </div>

      <!-- 用户查询 -->
      <div style="display:flex;flex-wrap:wrap;align-items:center;gap:10px;margin-bottom:20px;">
        <el-input
          v-model.trim="searchNickname"
          placeholder="搜索昵称（可选）"
          clearable
          @keyup.enter.native="handleSearch"
          style="width:180px;"
        ></el-input>
        <el-input
          v-model.trim="searchOpenid"
          placeholder="搜索OpenID（可选）"
          clearable
          @keyup.enter.native="handleSearch"
          style="width:200px;"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch" :loading="loading">查询</el-button>
        <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
      </div>

      <div v-if="error" class="error">{{ error }}</div>

      <el-empty v-if="!loading && searched && users.length === 0" description="未找到用户" />

      <!-- 用户列表 -->
      <div v-if="users.length > 0">
        <el-table :data="users" border stripe v-loading="loading" element-loading-text="加载中..." row-key="id">
          <el-table-column prop="id" label="用户ID" width="100" align="center" />
          <el-table-column prop="openid" label="OpenID" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.openid" placement="top" :disabled="!scope.row.openid">
                <span>{{ scope.row.openid || '-' }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="nickname" label="昵称" min-width="150" />
          <el-table-column prop="avatarUrl" label="头像" width="90" align="center">
            <template slot-scope="scope">
              <el-avatar v-if="scope.row.avatarUrl" :src="scope.row.avatarUrl" :size="36" />
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="当前个人收益比例" min-width="140" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.customRate != null" style="color:#409EFF;font-weight:600;">
                {{ scope.row.customRate }}%
              </span>
              <span v-else style="color:#C0C4CC;">未设置</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 0" type="success" size="small">正常</el-tag>
              <el-tag v-else-if="scope.row.status === 1" type="danger" size="small">封禁</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="deviceRisk" label="设备风险" width="90" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.deviceRisk === 0" type="success" size="small" effect="plain">正常</el-tag>
              <el-tag v-else-if="scope.row.deviceRisk === 1" type="danger" size="small" effect="plain">风险</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-edit"
                :disabled="scope.row.status === 1"
                @click="openEditDialog(scope.row)"
              >
                编辑比例
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container" v-if="pagination.total > pagination.pageSize">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>

    <!-- 编辑个人收益比例弹窗 -->
    <el-dialog title="编辑用户个人收益比例" :visible.sync="dialogVisible" width="460px" append-to-body :close-on-click-modal="false">
      <el-form :model="editForm" label-width="120px" ref="editFormRef" :rules="editRules">
        <el-form-item label="用户ID">
          <el-input v-model="editForm.id" disabled />
        </el-form-item>
        <el-form-item label="用户昵称">
          <el-input v-model="editForm.nickname" disabled />
        </el-form-item>
        <el-form-item label="自定义个人收益比例" prop="customRate">
          <el-input-number
            v-model="editForm.customRate"
            :step="1"
            placeholder="请输入比例"
            :disabled="editForm.clearRate"
            style="width:100%;"
          />
        </el-form-item>
        <el-form-item label=" ">
          <el-checkbox v-model="editForm.clearRate" @change="onClearRateChange">
            清除个人收益比例（设为空）
          </el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确认修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get, put } from '@/utils/http'

export default {
  name: 'UserManagement2',
  data() {
    return {
      searchNickname: '',
      searchOpenid: '',
      users: [],
      loading: false,
      searched: false,
      error: '',
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      submitting: false,
      editForm: {
        id: null,
        nickname: '',
        customRate: null,
        clearRate: false
      },
      editRules: {
        customRate: [
          {
            validator: (rule, value, callback) => {
              if (this.editForm.clearRate) {
                callback()
              } else if (value == null || value === '') {
                callback(new Error('请输入个人收益比例'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    // 不自动加载，等用户输入
    this.fetchUsers()
  },
  methods: {
    async fetchUsers() {
      this.loading = true
      this.error = ''
      this.searched = true
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        if (this.searchNickname) {
          params.nickname = this.searchNickname
        }
        if (this.searchOpenid) {
          params.openid = this.searchOpenid
        }
        const result = await get('/admin/users', params)
        const data = result && result.data ? result.data : {}
        this.users = Array.isArray(data.users) ? data.users : []
        this.pagination.total = data.total || 0
        this.pagination.pageSize = data.pageSize || this.pagination.pageSize
        this.pagination.page = data.page || this.pagination.page
      } catch (e) {
        this.error = e && e.message ? e.message : '获取用户列表失败'
        this.users = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },

    handleSearch() {
      this.pagination.page = 1
      this.fetchUsers()
    },

    resetSearch() {
      
      this.searchNickname = ''
      this.searchOpenid = ''
      this.pagination.page = 1
      this.users = []
      this.pagination.total = 0
      this.searched = false
      this.error = ''
    },

    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchUsers()
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchUsers()
    },

    openEditDialog(user) {
      this.editForm = {
        id: user.id,
        nickname: user.nickname || '',
        customRate: user.customRate != null ? user.customRate : null,
        clearRate: user.customRate == null
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.clearValidate()
        }
      })
    },

    onClearRateChange(val) {
      if (val) {
        this.editForm.customRate = null
      }
    },

    async handleSubmit() {
      try {
        await this.$refs.editFormRef.validate()
      } catch {
        return
      }

      this.submitting = true
      try {
       const payload = this.editForm.clearRate
          ? { clearCustomRate: true }
          : { customRate: this.editForm.customRate }
        const result = await put(`/admin/users/${this.editForm.id}`, payload)
        this.$message.success(result.msg || '个人收益比例修改成功')
        this.dialogVisible = false
        // 更新列表中对应行的数据
        const user = this.users.find(u => u.id === this.editForm.id)
        if (user) {
          user.customRate = this.editForm.clearRate ? null : this.editForm.customRate
        }
      } catch (e) {
        this.$message.error(e.message || '修改失败')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.error {
  color: #f87171;
  padding: 10px;
  background-color: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 4px;
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.el-card.animate__animated,
.el-table.animate__animated {
  --animate-duration: 0.3s;
}
</style>
